import { getCalculateSessionId } from '../../../comparator-graph-legacy-api';
import { ComparatorCalculationResult as MoneysureCalculationResult } from './types';
import moment from 'moment';

export class MoneysureQueryProvider {
  public getCurrentDateTimeFormatted() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed, so add 1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }

  public validateMoneysureCalculateVariables = (
    searchCriteria: object,
    credentials: object
  ) => {
    return {
      input: {
        request: {
          policyPolicyDetails: [
            {
              paymentTermInMonths: 1,
              partyPolicyHolders: [
                {
                  birthDate: moment(
                    searchCriteria['birthdate'],
                    'DD-MM-YYYY'
                  ).format('YYYY-MM-DD'),
                  genderOrLegalPersonType: searchCriteria['gender'],
                },
              ],
              coverageMedicalExpenses: [
                {
                  sumInsured: parseInt(searchCriteria['dailyRate']),
                  returnCommissionPercentage: 0,
                  underwritingSurchargePercentage:
                    searchCriteria['decision'] === 'ACC' &&
                      searchCriteria['totalPercentageRating'] === null
                      ? 0
                      : searchCriteria['totalPercentageRating'] || 0,
                },
              ],
              effectiveDate: moment().format('YYYY-MM-DD'),
            },
          ],
          commonTechnical: [
            {
              senderId: credentials['clientId'],
              sessionId: getCalculateSessionId(),
              transactionReference: this.getCurrentDateTimeFormatted(),
            },
          ],
        },
      },
    };
  };

  public validateMoneysureRecalculateVariables = (
    searchCriteria: object,
    credentials: object
  ) => {
    return {
      input: {
        request: {
          policyPolicyDetails: [
            {
              paymentTermInMonths: 1,
              partyPolicyHolders: [
                {
                  birthDate: moment(
                    searchCriteria['birthdate'],
                    'DD-MM-YYYY'
                  ).format('YYYY-MM-DD'),
                  genderOrLegalPersonType: searchCriteria['gender'],
                },
              ],
              coverageMedicalExpenses: [
                {
                  sumInsured: parseInt(searchCriteria['sumInsured']),
                  returnCommissionPercentage: 0,
                  underwritingSurchargePercentage:
                    searchCriteria['totalPercentageRating'] || 0,
                },
              ],
              effectiveDate: moment().add(1, 'day').format('YYYY-MM-DD'),
            },
          ],
          commonTechnical: [
            {
              senderId: credentials['clientId'],
              sessionId: searchCriteria['sessionId'],
              transactionReference:
                searchCriteria['selectedProduct'].commonTechnical[0]
                  .transactionReference,
            },
          ],
        },
      },
    };
  };

  public validateSuppliersVariables(
    result: MoneysureCalculationResult
  ): object {
    const productKrns = result.policyPolicyDetails?.map((item) => {
      return item.productCode;
    });

    return {
      productKrns: productKrns,
      productCategory: 'EVENT_BASED',
    };
  }
}
